var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value"},[(_vm.data == null)?_c('i',{staticClass:"el-icon-loading"}):_vm._t("default",function(){return [_vm._v(_vm._s(_vm.getValue())+_vm._s(_vm.suffix))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }